import React from 'react';
import './add anoncement.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon} from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message,TreeSelect} from "antd";
import { UploadOutlined } from '@ant-design/icons';

const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;

class AddAnoncement extends React.Component {
    state = {
        title_ar:'',
        description_en:'',
        title_en:'',
        description_ar:'',
        link:'',
        img:null,
        selectedFile: null,
        userType:'all',
        users:[],
        usersId:null,
        usersIds:[],
        imgName:''
    };

    constructor(props){
        super(props)
        this.fileChangedHandler = this.fileChangedHandler.bind(this);
        window.scrollTo(0,0)
        if(this.props.isRTL){
          allStrings.setLanguage('ar')
        }else{
          allStrings.setLanguage('en')
        } 
    }
    componentDidMount(){
        if(this.props.isRTL){
          allStrings.setLanguage('ar')
        }else{
          allStrings.setLanguage('en')
        }
    }
    /**
    * add request
    */
    add = () => {
        const {description_en,title_ar,img,description_ar,title_en,usersId,userType,link} = this.state
        let l = message.loading('Wait..', 1.5)
        if(img == null)
          l.then(() => message.error(allStrings.completeData, 1.5) )
        if(hasValue(description_en)&&hasValue(description_ar)&&hasValue(title_en)
        &&hasValue(title_ar)&&hasValue(link)){
           
            var data = new FormData()
            data.append('description_en',description_en)
            data.append('title_ar',title_ar)
            data.append('description_ar',description_ar)
            data.append('title_en',title_en)
            data.append('link',link)
            if(userType !== 'all'){
              data.append('userType',userType)
            }
            if(usersId !== null){
                data.append('users',JSON.state(usersId))
            }
            if(img != null){
              data.append('img',img); 
            }
            axios.post(`${BASE_END_POINT}ads`,data,{
            headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization':`Bearer ${this.props.currentUser.token}`,
            'Accept-Language':this.props.isRTL?'ar':'en'
            },
            })
            .then(response=>{
            console.log("add news  ",response.data)
            l.then(() => message.success(allStrings.done, 2.5) )
            this.props.history.goBack() 
            })
            .catch(error=>{
                console.log(error.response)
                l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))
            })
        }
    }
    /**
      * get Users request
    */
    getUsersWithoutPagenation = (type) =>{
      let url = `${BASE_END_POINT}withoutPagenation/get`
      if(type !=="ALL"){
        url = `${BASE_END_POINT}withoutPagenation/get?type=${type}`
      }
      axios.get(url,{
        headers:{
          'Authorization':`Bearer ${this.props.currentUser.token}`,
          'Accept-Language':this.props.isRTL?'ar':'en'
        }
      })
      .then(response=>{
        console.log("USERS   ",response.data)
  
         this.setState({users:response.data.users})
         let usersIds=[]
         response.data.users.forEach(user => {
             usersIds.push(user.id)
         });
         console.log("USERS ",usersIds)
         this.setState({usersIds:usersIds})
      })
      .catch(error=>{
        console.log("error   ",error.response)
        console.log("error2   ",error)
      })
    }
      /**
      * form submit Handler
      */
      submitHandler = event => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.add()
      };
      /**
      * form inputs Handler
      */
      changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
      };

      /**
      * upload file
      */
      fileChangedHandler = event => {
        this.setState({
          img: event.target.files[0],
          imgName: event.target.files[0].name,
          imgType:"data"
        })
      }
      /**
      * remove file
      */
      removeFile = () => {
        this.setState({
          img:null,
          imgName:'',
          imgType:"url"
        });
      }
     
     
  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('ANONCEMENTS')) return <Redirect to='/Home' />


  return (
    <div className="App">
        
        <MDBContainer>
            <MDBRow>
                <MDBCol xl ="12" lg = "12" md="12" sm="12">
                    <div className="infoCard">
                        <Card className="editCard" style={{overflow: 'visible',outline:'none',marginBottom:'0px'}}>
                        <CardMedia
                        style={{height:"0px"}}
                        />
                        <CardHeader></CardHeader>
                        <div  style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                            <div className="topIcon" style={{background:'#117183'}}>
                                <span className="material-icons" style={{color:'white',fontSize:23}}>featured_video</span>
                            </div>
                            <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                            marginLeft:this.props.isRTL?'0':'0rem',marginRight:this.props.isRTL?'0rem':'0'}}>
                            <p>{allStrings.addAnoncement}</p>
                            </div>
                        </div>
                        <CardContent style={{minHeight:"390px",outline:'none'}}>
                        <MDBContainer>
                            <MDBRow>
                                <MDBCol md="12">
                                <form
                                className="needs-validation"
                                onSubmit={this.submitHandler}
                                noValidate
                                >
                                    
                                    <div className="grey-text">
                                        <MDBRow>
                                          <MDBCol md="6">
                                              <div className="md-form">
                                                  <label htmlFor="form3" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishTitle}</label>
                                                  <input onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') }  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.title_en} type="text" id="form3" name="title_en" className="form-control" onChange={this.changeHandler} required validate/>
                                                  <div class="valid-feedback">{allStrings.correct}</div>
                                                  <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                              </div>
                                          </MDBCol>
                                          <MDBCol md="6">
                                              <div className="md-form">
                                                  <label htmlFor="form32" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicTitle}</label>
                                                  <input onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.title_ar} type="text" id="form32" name="title_ar" className="form-control" onChange={this.changeHandler} required validate/>
                                                  <div class="valid-feedback">{allStrings.correct}</div>
                                                  <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                              </div>
                                          </MDBCol>
                                            
                                        </MDBRow>
                                        
                                        <MDBRow>
                                          <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form3" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicDescription}</label>
                                              <br></br>
                                              <textarea  name="description_ar" onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/^[A-Za-z0-9 ]+$/g,'') }  style={{border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} type="text" id="form90" className="form-control" required validate onChange={this.changeHandler}  defaultValue={this.state.description_ar} />
                                              <div class="valid-feedback">{allStrings.correct}</div>
                                              <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                          </MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                          <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form31" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishDescription}</label>
                                              <br></br>
                                              <textarea  name="description_en" onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9\s]/g,'') }  style={{border:'none',borderBottom:'1px solid #dededede',direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 7px'}} type="text" id="form90" className="form-control" required validate onChange={this.changeHandler}  defaultValue={this.state.description_en} />
                                              <div class="valid-feedback">{allStrings.correct}</div>
                                              <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                          </MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                           <MDBCol md="12">
                                                <div className="md-form">
                                                    <label htmlFor="form3" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.link}</label>
                                                    <input  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.link} type="text" id="form2" name="link" className="form-control" onChange={this.changeHandler} required validate/>
                                                    <div class="valid-feedback">{allStrings.correct}</div>
                                                    <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                        <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                            <MDBCol md="6">
                                                <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.userType}</label>
                                                <TreeSelect 
                                                    virtual={false}
                                                    showSearch={false} 
                                                    disabled={this.state.actionType==="VIEW"?true:false}
                                                    style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                    treeCheckable = {false}         
                                                    treeNodeFilterProp="title"                      
                                                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                    placeholder={allStrings.userType}
                                                    onChange={(value) => {
                                                    console.log(value)
                                                    this.setState({userType:value,users:[]});
                                                    this.getUsersWithoutPagenation(value)
                                                    }} 
                                                
                                                >
                                                    <TreeNode value="ALL" title={allStrings.all} key="ALL" />
                                                    <TreeNode value="ADMIN" title={allStrings.admin} key="ADMIN" />
                                                    <TreeNode value="SUB-ADMIN" title={allStrings.subAdmin} key="SUB-ADMIN" />
                                                    <TreeNode value="USER" title={allStrings.client} key="USER" />
                                                    
                                                    
                                                </TreeSelect>
                                            </MDBCol>
                                            {this.state.userType !== 'all'&&
                                            <MDBCol md="6">
                                              <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.users}</label>
                                              <TreeSelect 
                                                  virtual={false}
                                                  showSearch={true} 
                                                  maxTagCount="6"
                                                  disabled={this.state.actionType==="VIEW"?true:false}
                                                  style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                                  treeCheckable = {true}        
                                                  showCheckedStrategy= {SHOW_PARENT}   
                                                  treeNodeFilterProp="title"                      
                                                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                  placeholder={allStrings.users}
                                                  onChange={(value) => {
                                                  console.log(value)
                                                    this.setState({value:value});
                                                    
                                                  }} 
                                              
                                              >
                                                  
                                                  {this.state.users.map(val=>(
                                                      <TreeNode value={val.id} title={val.fullname} key={val.id} />
                                                  ))}
                                              </TreeSelect>
                                            </MDBCol>
                                            }
                                        </MDBRow>
                                        <MDBCol md="12">
                                            <div className="fileUpload2"> 
                                                <input  key={this.state.img} type='file' className="upImgs2" onChange={this.fileChangedHandler} ></input>
                                                <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.upload}</span></span>
                                            </div>
                                            <div className="preview" style={{marginBottom:'20px'}}>
                                            {this.state.img&&
                                            <div style={{display:"inline-block",width: '100%',border: '1px solid mediumaquamarine'}}>
                                                <img alt="" src={URL.createObjectURL(this.state.img)}  className="previewImg2"/>
                                                <span className="imgName">{this.state.imgName}</span>
                                                <MDBIcon icon="trash" className="mr-2 removeImg2" style={{top:'103px'}}
                                                onClick={() => this.removeFile()}  ></MDBIcon>
                                            </div>
                                            }
                                            </div>
                                            
                                        </MDBCol>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <div className="text-center">
                                        <MDBBtn
                                          type="submit" style={{background:'#117183'}}
                                          rounded
                                          className="btn-block z-depth-1a"
                                        >
                                            <MDBIcon icon="plus" className="mr-2" />
                                            {allStrings.addAnoncement}        
                                        </MDBBtn>
                                    </div>
                                </form>
                                </MDBCol>
                                
                            </MDBRow>
                        </MDBContainer>
                        </CardContent>
                    </Card>
                </div>
            </MDBCol>
            </MDBRow>
            
            
        </MDBContainer>
      
    </div> 
  )
  }
}



const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  });
  
  const mapDispatchToProps = {
  };
  
  export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(AddAnoncement)
  );